import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getAuditTrailByid, getAuditTrailByPreview } from '../../../../redux/auditTrailSlice';
import Loader from '../../../../common/Loader';
import { showSnackbar } from '../../../../redux/snackbarSlice';

/**
 * VersionHistoryCopyFlow Component
 * Entry point for copying from version history
 * This component handles copying nodes from historical versions by:
 * 1. Fetching the audit trail data which contains the historical node data
 * 2. Showing a document selector to choose target document
 * 3. Showing a position selector to choose where to paste
 * 4. Performing the copy operation
 */
const VersionHistoryCopyFlow = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { audit_trail_id } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const initializeCopyFlow = async () => {
      try {
        // Fetch audit trail data
        const resp = await dispatch(getAuditTrailByid({ id: audit_trail_id }));
        const auditData = resp.payload.results;
        
        
        // For now, show an error message that this feature is not yet fully implemented
        dispatch(showSnackbar({ 
          message: 'Version history copy is not yet fully implemented. Please use the regular copy function from the current document version.', 
          type: 'info' 
        }));
        
        // Navigate back
        navigate(-1);
        
      } catch (err) {
        console.error('Error initializing copy flow:', err);
        setError('Failed to initialize copy flow');
        dispatch(showSnackbar({ message: 'Failed to initialize copy flow', type: 'error' }));
        navigate(-1);
      }
    };

    if (audit_trail_id) {
      initializeCopyFlow();
    }
  }, [audit_trail_id, dispatch, navigate]);

  if (error) {
    return <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>{error}</div>;
  }

  return <Loader text="Initializing copy..." />;
};

export default VersionHistoryCopyFlow;
